import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createApiClient } from '@room/frontend-sdk';
import { AppErrorBoundary, applyThemeFromQuery, registerDefaultTiles, setAuthAPI } from '@room/shared-ui';
import { App } from './App';
import './styles/debug-theme.css';
import './styles/messenger-theme.css';

// Register default home tiles
registerDefaultTiles();

applyThemeFromQuery();

const api = createApiClient({
  baseURL: '/api',
  onUnauthorized: () => {
    window.location.href = '/login';
  },
});

setAuthAPI({
  getSession: () => api.get('/auth/session'),
});

const queryClient = new QueryClient();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </AppErrorBoundary>
  </StrictMode>
);
